import { render, staticRenderFns } from "./setpassword.vue?vue&type=template&id=20d489e3&"
import script from "./setpassword.vue?vue&type=script&lang=js&"
export * from "./setpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports